/* src/app/external-user/advance-details/advance-payment-status/advance-payment-status-profile/advance-payment-status-profile.component.css */
body {
  background-color: #f2f2f2;
  color: #000000;
}
.page-wrapper {
  padding: 2rem 1rem;
  display: flex;
  justify-content: center;
  background: #f5f7fa;
}
.row {
  margin: 0px !important;
}
.header_bg {
  background: url(/assets/images/ots_bg.png) no-repeat center top;
  text-align: center;
  background-size: cover;
}
.logo {
  text-align: left;
  color: #fff;
  padding: 12px 0px 0px 25px;
}
.user_main {
  float: right;
  text-align: right;
  color: white;
  border-left: solid 1px rgba(0, 0, 0, 0.2);
  padding: 30px 30px 30px 0px;
}
.user_main p {
  float: right;
  padding-right: 10px;
}
.user_icon {
  float: right;
  background-color: #008ad0;
  padding: 8px;
  border-radius: 30px;
  font-size: 20px;
}
.userbtn_main {
  margin-top: -60px;
  position: absolute;
  right: 0px;
}
.dropdown-menu {
  right: 15px;
  left: auto;
  border-radius: 0px;
  padding: 0px;
  border: 1px solid #e4e4e4;
}
.dropdown-menu > li > a {
  display: block;
  padding: 15px 100px 15px 10px;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  color: #333;
  white-space: nowrap;
  border-bottom: 1px solid #e0e0e0;
}
.dropdown-menu > li > a:hover {
  background-color: #008ad0;
  color: #ffffff;
}
.drop_downicon {
  color: #ffffff;
  position: absolute;
  right: 13px;
  top: -24px;
  font-size: 30px;
}
.success_main {
  background: #ffffff;
  padding: 18px 0px 9px 0px;
  margin-bottom: 10px;
  border-bottom: 1px solid #dedede;
}
.success_main p {
  font-size: 22px;
  float: left;
}
.smalltxt {
  margin: 13px;
  font-size: 14px;
  color: #7b7b7b;
}
.success_main i {
  background-color: #2fa841;
  padding: 8px;
  border-radius: 30px;
  color: #fff;
}
.success_print {
  float: right;
  margin-right: 26px;
}
.print_icon {
  font-size: 28px !important;
  background: transparent !important;
  color: #f26f21 !important;
}
.below_header {
  padding: 10px;
  line-height: 34px;
}
.order_id {
  font-size: 20px;
}
.order_icon {
  padding: 10px;
  color: #040404;
  border-radius: 4px;
  font-size: 30px !important;
  font-weight: bold !important;
}
.detail_list {
  clear: both;
  padding-top: 10px;
}
.payment_detail_main {
  margin-top: 30px;
  clear: both;
}
.payment_detailtxt {
  font-size: 20px;
  font-weight: 500;
}
.payment_detail_icon {
  padding: 10px;
  color: #040404;
  border-radius: 4px;
  font-size: 30px !important;
  font-weight: bold !important;
}
.blw_paymentdetail {
  margin-left: 5px;
}
.full_paymenttxt {
  font-size: 14px;
  margin: -2px 10px;
  color: #040404;
}
.full_payment {
  font-size: 18px;
  margin: -2px 10px;
  color: #040404;
  font-weight: bold;
  line-height: 32px;
}
.gohome {
  margin: 16px 8px !important;
  background-color: #2fa841 !important;
  color: #ffffff !important;
  border-radius: 30px !important;
  text-transform: capitalize !important;
  height: auto !important;
  line-height: 0px !important;
  padding: 15px 8px !important;
}
.gohomeFail {
  margin: 16px 8px !important;
  background-color: #f26d22 !important;
  color: #ffffff !important;
  border-radius: 30px !important;
  text-transform: capitalize !important;
  height: auto !important;
  line-height: 0px !important;
  padding: 15px 8px !important;
}
.home_icon {
  font-size: 20px !important;
}
.btn:hover {
  color: #ffffff;
}
.paymentFailure {
  background-color: #f26d22 !important;
}
@media (min-width: 300px) and (max-width: 600px) {
  .user_main {
    padding: 15px 28px 7px 0px;
  }
  .logo {
    padding: 25px 14px 0px 25px;
  }
  .row {
    margin-right: -15px;
    margin-left: -15px;
  }
  .success_main {
    padding: 18px 0px 9px 0px;
  }
  .success_print {
    margin-right: 0px;
    float: left;
  }
}
@media (min-width: 600px) and (max-width: 900px) {
  .cc_main {
    float: none;
  }
}
@media only screen and (min-width: 993px) {
  .container {
    width: 100% !important;
  }
}
@media (min-width: 1200px) {
  .container {
    width: 1170px !important;
  }
}
/*# sourceMappingURL=advance-payment-status-profile.component.css.map */
